import * as CSS from 'csstype';

export const formDiv: CSS.Properties = { 
    width: '32rem',
    borderRadius: '.4rem',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-around',
}

export const inputLabel: CSS.Properties = { 
    color: '#45CB85'
}

export const buttonDiv: CSS.Properties = { 
    width: '7rem',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'end',
    alignItems: 'flex-end',
    paddingBottom: '.1rem'
}
export const searchField: CSS.Properties = { 
    width: '17.5rem'
}
export const searchDiv: CSS.Properties = { 

}
export const searchButton: CSS.Properties = { 
    backgroundColor: '#6A7FDB',
    width: '5rem',
    height: '2rem',
}